import { Pipe, PipeTransform } from '@angular/core';

import { isEmpty } from 'lodash';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { FiltersFormData } from '../types';

@Pipe({ name: 'checkForFieldCallback' })
export class FiltersFormCheckForFieldsCallbackPipe implements PipeTransform {
  constructor() {}
  async transform(formData: FiltersFormData, fieldKey: string | unknown, formState: Observable<any>) {
    const fieldObject = formData[fieldKey as string];
    return typeof fieldObject === 'function'
      ? formState.pipe(
          map(v => {
            if (!v || isEmpty(v)) return null;
            return fieldObject(v);
          }),
        )
      : of(fieldObject);
  }
}
